module.exports = __webpack_public_path__ + "img/login-bg.37bcf760.jpeg";